<template>
  <list-double></list-double>
</template>
<script>
import listDouble from "@/view/double/list";
export default {
  name: "doubleList",
  components: {
    listDouble
  }
};
</script>
